import TitleBar12 from './titleBar12';
export default TitleBar12;
